module.exports = __webpack_public_path__ + "img/yellow-square-table-12.09c9a31c.png";